import { render, staticRenderFns } from "./AS_AnnualStatement.vue?vue&type=template&id=5a4b73af&scoped=true&"
import script from "./AS_AnnualStatement.vue?vue&type=script&lang=js&"
export * from "./AS_AnnualStatement.vue?vue&type=script&lang=js&"
import style0 from "./AS_AnnualStatement.vue?vue&type=style&index=0&id=5a4b73af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4b73af",
  null
  
)

export default component.exports